"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = __importStar(require("react"));
var SvgCalendar = function (props) { return ((0, jsx_runtime_1.jsxs)("svg", __assign({ fill: "none", height: 24, width: 22, xmlns: "http://www.w3.org/2000/svg" }, props, { children: [(0, jsx_runtime_1.jsx)("path", { d: "M1.103 9.21h19.606", opacity: 0.4, stroke: "#fff", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5 }), (0, jsx_runtime_1.jsx)("path", { clipRule: "evenodd", d: "M5.264 13.52a.75.75 0 0 1 .75-.75h.01a.75.75 0 0 1 0 1.5h-.01a.75.75 0 0 1-.75-.75zm5.641-.75a.75.75 0 1 0 0 1.5h.01a.75.75 0 1 0 0-1.5zm4.882 0a.75.75 0 0 0 0 1.5h.01a.75.75 0 0 0 0-1.5zm0 4.29a.75.75 0 0 0 0 1.5h.01a.75.75 0 0 0 0-1.5zm-5.632.75a.75.75 0 0 1 .75-.75h.01a.75.75 0 0 1 0 1.5h-.01a.75.75 0 0 1-.75-.75zm-4.14-.75a.75.75 0 0 0 0 1.5h.01a.75.75 0 0 0 0-1.5z", fill: "#fff", fillRule: "evenodd", opacity: 0.4 }), (0, jsx_runtime_1.jsxs)("g", __assign({ stroke: "#fff", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5 }, { children: [(0, jsx_runtime_1.jsx)("path", { d: "M15.348 1.038V4.67M6.462 1.038V4.67" }), (0, jsx_runtime_1.jsx)("path", { clipRule: "evenodd", d: "M15.562 2.78H6.248C3.018 2.78 1 4.587 1 7.906v9.989c0 3.371 2.018 5.219 5.248 5.219h9.304c3.24 0 5.248-1.816 5.248-5.136V7.905c.01-3.319-1.997-5.124-5.238-5.124z" })] }))] }))); };
exports.default = SvgCalendar;
